module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attribute-panel",
    class: {
      'is-collapsed': _vm.isCollapsed,
      'is-expanded-view': _vm.isExpandedView
    },
    on: {
      "click": _vm.panelClickHandler
    }
  }, [(_vm.isCollapsed) ? _c('collapse-btn', {
    staticClass: "attribute-panel__expand-btn",
    attrs: {
      "hide-text": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.workbenchHeaderData) ? _c('div', {
    staticClass: "attribute-panel__header-nav"
  }, [_c('div', {
    staticClass: "attribute-panel__header-nav__dashboard",
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header-nav__dashboard_label text-button"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header-nav__status-details"
  }, [_c('div', {
    staticClass: "attribute-panel__header-nav__status-details__segment-type"
  }, [_vm._v("\n        " + _vm._s(_vm.getCampaignName(_vm.workbenchHeaderData.xandr_data)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header-nav__status-details__segment-type"
  }, [_vm._v("\n        " + _vm._s(_vm.getDestinations(_vm.workbenchHeaderData.destinations)) + "\n      ")]), _vm._v(" "), (_vm.workbenchHeaderData && _vm.workbenchHeaderData.activation_status && !_vm.workbenchHeaderData.dropped) ? _c('v-chip', {
    staticClass: "attribute-panel__header-nav__status-details__status",
    attrs: {
      "label": "",
      "dark": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.workbenchHeaderData.activation_status))]) : (_vm.workbenchHeaderData.dropped) ? _c('v-chip', {
    staticClass: "attribute-panel__header-nav__status-details__status",
    attrs: {
      "label": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.clickedDropped
    }
  }, [_vm._v("DROPPED")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "attribute-panel__header"
  }, [_c('div', {
    staticClass: "attribute-panel__header__segment-details"
  }, [(_vm.workbenchHeaderData) ? _c('div', {
    staticClass: "attribute-panel__header__segment-details__left"
  }, [_c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [(!_vm.editModeActive) ? _c('v-col', {
    staticClass: "flex-grow-1 attribute-panel__header__segment-details__left__name",
    attrs: {
      "md": "6"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.workbenchHeaderData.display_name) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editModeActive) ? _c('v-col', [_c('target-name', {
    attrs: {
      "attributePanel": true,
      "isNewTarget": false,
      "initialValue": _vm.originalDisplayName,
      "displayOverride": _vm.workbenchHeaderData.display_name,
      "targetType": _vm.workbenchHeaderData.target
    },
    on: {
      "updateName": function (val) { return (_vm.targetName = val); },
      "updateNameIsValid": _vm.onTargetNameIsValid
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.workbenchHeaderData.advertiser && _vm.workbenchHeaderData.advertiser.Name && !_vm.editModeActive) ? _c('v-col', {
    staticClass: "flex-shrink-1 attribute-panel__header__segment-details__left__name",
    attrs: {
      "md": "0"
    }
  }, [_vm._v("\n            |\n          ")]) : _vm._e(), _vm._v(" "), (_vm.workbenchHeaderData.advertiser && _vm.workbenchHeaderData.advertiser.Name && !_vm.editModeActive) ? _c('v-col', {
    staticClass: "flex-grow-1 attribute-panel__header__segment-details__left__name",
    attrs: {
      "md": "5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.workbenchHeaderData.advertiser.Name) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editModeActive) ? _c('v-col', [_c('advertiser-select', {
    ref: "advertiserSelect",
    attrs: {
      "placeholder": "Select",
      "attributePanel": true,
      "disabled": _vm.isByodTraitPresent,
      "initialValue": _vm.workbenchHeaderData.advertiser,
      "showAdvertiserId": false
    },
    on: {
      "update": function (val) { return _vm.onUpdateAdvertiser(val); }
    },
    model: {
      value: (_vm.workbenchHeaderData.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.workbenchHeaderData, "advertiser", $$v)
      },
      expression: "workbenchHeaderData.advertiser"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.targetInfoEditable) ? _c('div', {
    staticClass: "attribute-panel__header__segment-details__right"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditMode.apply(null, arguments)
      }
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header__search-section"
  }, [_c('search-input', {
    ref: "searchInput",
    staticClass: "attribute-panel__header__search-section__search",
    class: {
      'cursor-disabled': _vm.viewOnly
    },
    attrs: {
      "debounce": 500,
      "locked": _vm.viewOnly
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  })], 1), _vm._v(" "), _c('bread-crumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "crumbs": _vm.crumbs,
      "locked": _vm.viewOnly
    },
    on: {
      "click": _vm.crumbClickHandler
    }
  }), _vm._v(" "), _c('back-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchActive),
      expression: "isSearchActive"
    }],
    staticClass: "attribute-panel__back-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  }, [_vm._v("Back To Browse")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__body"
  }, [(_vm.tooManySearchResults) ? _c('small-text', [_vm._v("\n      Too many results to display (" + _vm._s(_vm.searchResultsCount) + "). Please refine your search.\n    ")]) : (_vm.isSearchActive) ? _c('search-results', {
    ref: "searchResults",
    attrs: {
      "locked": _vm.viewOnly || _vm.selectedEpsilonDatasetFamily,
      "results": _vm.searchResults,
      "selectedValues": _vm.selectedValues,
      "count": _vm.searchResultsCount,
      "advertiser": _vm.workbenchHeaderData.advertiser
    },
    on: {
      "item-selected": _vm.onSelect
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentList) ? _c('list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "listGroup": _vm.currentList,
      "id": "attributePanelID",
      "locked": _vm.viewOnly || _vm.selectedEpsilonDatasetFamily,
      "selectedValues": _vm.selectedValues,
      "advertiser": _vm.workbenchHeaderData.advertiser
    },
    on: {
      "expandNode": _vm.itemSelectedHandler,
      "onSelect": _vm.onSelect
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('dropped-attributes-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b12d975"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/attributePanel/components/AttributePanel.vue
// module id = 2390
// module chunks = 0